import React, {useCallback} from 'react';
import {observer} from 'mobx-react-lite';
import intl from 'react-intl-universal';
import {useRootStore, useUserState} from '@stores/AppStateContext';
import {useCrudServices} from '../../../platform/hooks/useServiceCombinations';
import {searchContent} from '../../../actions/searchContent';
import {SearchHeader as SearchHeaderPure} from '../../components/SearchResults/SearchHeader';

export interface SearchHeaderProps {
    haveResults: boolean;
}

export const SearchHeader = observer(({haveResults}: SearchHeaderProps) => {
    const rootStore = useRootStore();
    const userState = useUserState();
    const crudServices = useCrudServices();
    const activeWorkspace = rootStore.view.workspace!;

    let label: string;
    let nothingFoundAnywhere = false;
    if (rootStore.search.queryPerformed) {
        if (!haveResults) {
            label = intl.get('search_results.no_results', {searchQuery: rootStore.search.textInput}).d('No results for: <b>{searchQuery}</b>');
            nothingFoundAnywhere = true;
        } else {
            label = intl.get('search_results.search_results').d('Search results');
        }
    } else if (rootStore.search.isSearching) {
        label = intl.get('search_results.search_in_progress').d('Search in progress');
    } else {
        label = intl.get('search_results.search_contents').d('Search for content');
    }

    const isCallToSearch = !rootStore.search.queryPerformed && !rootStore.search.isSearching;

    const onSearch = useCallback(async () => {
        searchContent(crudServices, rootStore, userState!);
    }, [activeWorkspace, crudServices, rootStore, userState]);

    return (
        <SearchHeaderPure
            label={label}
            isCallToSearch={isCallToSearch}
            nothingFoundAnywhere={nothingFoundAnywhere}
            isSearching={rootStore.search.isSearching}
            searchButtonLabel={intl.get('search.search').d('Search')}
            searchButtonTooltip={intl.get('tooltip.searchHeader.pressEnter').d('Press Enter to Search Content')}
            onSearch={onSearch}
        />
    );
});
